import { GameConstants } from "../../../GameConstants";
import { GameVars } from "../../../GameVars";
import * as Carrom from "carrom-king-engine";
import { BootScene } from "../../BootScene";

export class MessageLayer extends Phaser.GameObjects.Container {

    constructor(scene: Phaser.Scene, messageType: string) {

        super(scene);

        this.x = GameConstants.GAME_WIDTH / 2;
        this.y = GameConstants.GAME_HEIGHT / 2;

        this.scaleY = GameVars.scaleY;

        const backgroundBig = new Phaser.GameObjects.Image(this.scene, 0, 0, "texture_atlas_1", "msg_base");
        backgroundBig.setScale(2);
        backgroundBig.visible = false;
        this.add(backgroundBig);

        const backgroundSmall = new Phaser.GameObjects.Graphics(this.scene);
        backgroundSmall.fillStyle(0x132A4B, .85);
        backgroundSmall.fillRoundedRect(-GameConstants.GAME_WIDTH / 2 * .55, -40, GameConstants.GAME_WIDTH * .55, 80, 15);
        backgroundSmall.visible = false;
        this.add(backgroundSmall);

        const gameText = this.scene.game.cache.json.get("game-text");

        let foulText: Phaser.GameObjects.Text;

        switch (messageType) {

            case Messages.FIRST_TURN:

                backgroundBig.visible = true;

                let msg = GameVars.currentTurnPlayerId === GameVars.playerData.id ? gameText.YOU_START : gameText.YOUR_OPPONENT_START;

                const youStartText = new Phaser.GameObjects.Text(this.scene, 0, -30 + (BootScene.textYgap * -60), msg, { fontFamily: "Teko-Medium", fontSize: "50px", color: "#FFFFFF" });
                youStartText.setOrigin(.5);
                youStartText.setShadow(0, 4, "#132A4B", 0, false, true);
                this.add(youStartText);

                if (GameVars.gameMode === Carrom.GameMode.PROFESSIONAL) {

                    const pocketAllText = new Phaser.GameObjects.Text(this.scene, 0, 22.5 + (BootScene.textYgap * -54), gameText.POCKET_ALL, { fontFamily: "Wolf-Sans-Regular", align: "center", fontSize: "32px", color: "#FFFFFF" });
                    pocketAllText.setOrigin(.5,BootScene.originY);
                    this.add(pocketAllText);

                    const blurredCircle = new Phaser.GameObjects.Image(this.scene, pocketAllText.width / 2 + 34, 25 + (BootScene.textYgap * -0), "texture_atlas_1", "blurred_circle");
                    blurredCircle.setScale(1.15);
                    this.add(blurredCircle);

                    const blackPuckIcon = new Phaser.GameObjects.Image(this.scene, pocketAllText.width / 2 + 34, 25 + (BootScene.textYgap * -0), "texture_atlas_1", GameVars.playerColor === Carrom.Color.BLACK ? "puck-black" : "puck-white");
                    this.add(blackPuckIcon);

                } else {
                    youStartText.y = 0 + (BootScene.textYgap * -62);
                }

                break;

            case Messages.TURN_CHANGE:

                backgroundBig.visible = true;

                let turnText = new Phaser.GameObjects.Text(this.scene, 0, 0 + (BootScene.textYgap * -60), gameText.YOUR_TURN, { fontFamily: "Teko-Medium", fontSize: "60px", color: "#FFFFFF" });
                turnText.setOrigin(.5);
                turnText.setShadow(0, 4, "#132A4B", 0, false, true);
                this.add(turnText);

                if (!GameVars.turnData) {

                    turnText.y = -25 + (BootScene.textYgap * -80);

                    const skippedTurnText = new Phaser.GameObjects.Text(this.scene, 0, 25 + (BootScene.textYgap * -57), gameText.OPPONENT_SKIPPED_TURN.replace("*", GameConstants.MISSED_TURNS_GAME_OVER_FORCED - GameVars.turnsToForceGameOver), { fontFamily: "Wolf-Sans-Regular", align: "center", fontSize: "28px", color: "#FFFFFF" });
                    skippedTurnText.setOrigin(.5,BootScene.originY);
                    this.add(skippedTurnText);
                }

                break;

            case Messages.STRIKER_POCKETED:

                backgroundBig.visible = true;

                foulText = new Phaser.GameObjects.Text(this.scene, 0, -25 + (BootScene.textYgap * -57), gameText.FOUL, { fontFamily: "Teko-Medium", fontSize: "48px", color: "#FFFFFF" });
                foulText.setOrigin(.5);
                foulText.setShadow(0, 4, "#132A4B", 0, false, true);
                this.add(foulText);

                const strikerPocketingText = new Phaser.GameObjects.Text(this.scene, 0, 25 + (BootScene.textYgap * -62), gameText.POCKETING_STRIKER, { fontFamily: "Wolf-Sans-Regular", align: "center", fontSize: "28px", color: "#FFFFFF" });
                strikerPocketingText.setOrigin(.5,BootScene.originY);
                this.add(strikerPocketingText);

                break;
            case Messages.SKIPPED_TURN:

                backgroundBig.visible = true;

                foulText = new Phaser.GameObjects.Text(this.scene, 0, -25 + (BootScene.textYgap * -60), gameText.FOUL, { fontFamily: "Teko-Medium", fontSize: "48px", color: "#FFFFFF" });
                foulText.setOrigin(.5,BootScene.originY);
                foulText.setShadow(0, 4, "#132A4B", 0, false, true);
                this.add(foulText);

                let str: string;

                if (GameConstants.MISSED_TURNS_GAME_OVER_FORCED - GameVars.turnsToForceGameOver === 1) {
                    str = gameText.SKIPPED_TURN;
                } else {
                    str = gameText.SKIPPED_TURNS.replace("*", GameConstants.MISSED_TURNS_GAME_OVER_FORCED - GameVars.turnsToForceGameOver);
                }

                const skippedTurnText = new Phaser.GameObjects.Text(this.scene, 0, 25 + (BootScene.textYgap * -60), str, { fontFamily: "Wolf-Sans-Regular", align: "center", fontSize: "28px", color: "#FFFFFF" });

                // const skippedTurnText = new Phaser.GameObjects.Text(this.scene, 0, 25, gameText.SKIPPED_TURN.replace("*", GameConstants.MISSED_TURNS_GAME_OVER_FORCED - GameVars.turnsToForceGameOver), { fontFamily: "Wolf-Sans-Regular", align: "center", fontSize: "28px", color: "#FFFFFF"});
                skippedTurnText.setOrigin(.5,BootScene.originY);
                this.add(skippedTurnText);

                break;

            case Messages.WAITING_FOR_ADVERSARY:

                backgroundSmall.visible = true;

                this.y = GameConstants.GAME_HEIGHT * 2 / 3;

                backgroundBig.setScale(.85);

                const waitingText = new Phaser.GameObjects.Text(this.scene, 0, 0 + (BootScene.textYgap * -45), gameText.WAITING, { fontFamily: "Wolf-Sans-Regular", align: "center", fontSize: "24px", color: "#FFFFFF" });
                waitingText.setOrigin(.5,BootScene.originY);
                this.add(waitingText);

                break;

            case Messages.WAITING_FOR_OPPONENT:

                backgroundSmall.visible = true;

                this.y = GameConstants.GAME_HEIGHT * 2 / 3;

                backgroundBig.setScale(.85);

                const _waitingText = new Phaser.GameObjects.Text(this.scene, 0, 0 + (BootScene.textYgap * -57), gameText.WAITING, { fontFamily: "Wolf-Sans-Regular", align: "center", fontSize: "24px", color: "#FFFFFF" });
                _waitingText.setOrigin(.5,BootScene.originY);
                this.add(_waitingText);

                break;

            default:
        }

        this.alpha = 0;

        this.scene.add.tween({
            targets: this,
            alpha: 1,
            ease: Phaser.Math.Easing.Cubic.Out,
            duration: 300,
        });
        if (messageType === Messages.WAITING_FOR_OPPONENT) {
            return;
        }
        this.scene.add.tween({
            targets: this,
            alpha: 0,
            ease: Phaser.Math.Easing.Cubic.Out,
            duration: 300,
            delay: 1750,
            onComplete: this.destroy,
            onCompleteScope: this
        });
    }
}
